import Auth from '../../../../../auth'

export default function FaultsCreateDirective() {
	return {
		template: require('./create.html'),
		transclude: true,
		restrict: 'E',
		scope: {},
		controller: CreateFaultConfigController,
		controllerAs: 'vm'
	};

	function CreateFaultConfigController(
		$scope,
		$timeout,
		$uibModal,
		gettextCatalog,
		faultsService,
		$state
	) {
		'ngInject';

		var vm = this;

		vm.faults = [];
		vm.name = '';
		vm.configurationId = {};
		vm.contactsList = [];
		vm.equipmentData = [];
		vm.param = {};
		vm.selectedEquipment = {};
		vm.errorFlag = false;
		vm.errorText = '';

		vm.numSelectedAssets = numSelectedAssets;
		vm.saveConfiguration = saveConfiguration;
		vm.selectAssetsButtonPressed = selectAssetsButtonPressed;
		init();

		function init() {
			$timeout(function () {
				vm.createConfigurationForm.$setValidity(
					'assets',
					vm.equipmentData.length > 0
				);
			});

			//the thing talks to multi-email directive
			$scope.$on('totalEmails', function (event, totalEmails) {
				vm.maxEmails = totalEmails.length;
			});
		}

		//display the number of assets selected from the picker
		function numSelectedAssets() {
			if (!vm.param._selected || !vm.param) {
				return 0;
			}

			return Object.keys(vm.param._selected).length;
		}

		//Select Asset Modal
		function selectAssetsButtonPressed() {
			var modalInstance = $uibModal.open({
				animation: true,
				template: require('../../../../../components/assetpicker/asset.multi.picker.html'),
				controller: 'AssetMultiPickerController',
				size: 'lg',
				resolve: {
					singleSelect: false,
					requiresSelection: true,
					maxSelection: function () {
						return 0;
					},
					selectedAssets: function () {
						var selected = {};

						if (vm.equipmentData) {
							for (var i = 0; i < vm.equipmentData.length; i++) {
								var e = vm.equipmentData[i];
								selected[e.id] = e;
							}
						}
						return selected;
					}
				}
			});

			modalInstance.result
				.then(function (selectedAssets) {
					vm.equipmentData = [];
					for (var key in selectedAssets.result) {
						vm.equipmentData.push(selectedAssets.result[key]);
					}
				})
				.finally(function () {
					vm.createConfigurationForm.$setValidity(
						'assets',
						vm.equipmentData.length > 0
					);
				});
		}

		$scope.faultConfigurationExists = function () {
			vm.duplicateConfigName = false;
			faultsService.getConfigByName(vm.name).then(function (response) {
				if (response.data.name === vm.name) {
					vm.duplicateConfigName = true;
				}
			}).catch(err => {
				if (404 != err.status)
					console.log(err)
			});
		}

		//Validate the form on submission then run the API call
		function saveConfiguration() {
			if (vm.createConfigurationForm.$valid) {
				//Need to validate that all rows in the fault table are submitted and not in editmode
				vm.loading = true;
				vm.errorText = null;
				const brand = Auth.getBrandClaim();

				faultsService
					.createConfig(vm.name, vm.contactsList, vm.equipmentData, vm.faults, brand)
					.then(
						function (response) {
							vm.loading = false;
							$state.go('alerts.faults.edit', {
								configurationId: response.data.id
							});
						},
						function (error) {
							vm.errorText = gettextCatalog.getString(
								'An error occurred while creating the Configuration'
							);
							vm.loading = false;
						}
					);
			}
		}
	}
}
